import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Col } from 'react-bootstrap';
import { LazyLoadImage } from "react-lazy-load-image-component";

import Coin from '../../../../styles/images/coin.png';
import { handleChangeDataTransferPage } from '../../../../redux/actions/pages/transfer';




const CardShopBranch = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {id, title, branch_id, branch_title, cash_back, logo, services} = props.data.item;



    const handleShopClick = () => {
        dispatch(handleChangeDataTransferPage('shopTitle', title));
        dispatch(handleChangeDataTransferPage('branchTitle', branch_title));
        dispatch(handleChangeDataTransferPage('shopId', id));
        dispatch(handleChangeDataTransferPage('branchId', branch_id));
        dispatch(handleChangeDataTransferPage('services', services));
        if(services.length > 0)
            dispatch(handleChangeDataTransferPage('serviceSelected', services[0].service));
        navigate('../transfer');
    };


    

    return (

            <Col xs={12} className="mb-4 px-0" role="button">
                <div className="div-store" onClick={handleShopClick}>
                    <div className="d-flex justify-content-center">
                        <div className="d-flex align-items-center">
                            <LazyLoadImage className="img-store-list" src={logo} alt={title} />
                        </div>

                        <div className="info mx-3">
                            <h6 className="mb-0">{title}</h6>
                            <span className="overflow-txt"  >
                                {branch_title}
                            </span>

                            <span className="d-flex justify-content-start" style={{whiteSpace: "nowrap"}} >
                                <span className="pull-back-info px-2 py-1 d-flex justify-content-center" >
                                    <div className="d-flex align-items-center">
                                        <img src={Coin} alt="بازگشت وجه" />
                                    </div>
                                    <div className="d-flex align-items-end mx-1" >
                                        <span style={{fontSize: "15px"}} >%{cash_back}</span> 
                                    </div>
                                    <span className="text-center d-flex flex-column justify-content-between" style={{flex: "1 1"}}>
                                        <span className="font-size-10 height-8">برگشت</span>
                                        <span className="font-size-10">وجـــــــــــه</span>
                                    </span>
                                    {/*<img src={CashBack} alt="بازگشت وجه" />*/}
                                </span>
                            </span>

                        </div>
                    </div>
                </div>
                    
            </Col>

    );
}

export default CardShopBranch;